import { a as __extends, c as __rest, d as __assign, _ as __makeTemplateObject } from '../../chunks/chunk-525a49bc.js';
import { Collapse } from 'antd';
import React from 'react';
import styled from 'styled-components';
import '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { d as defaultTheme, w as withDefaultTheme, e as withAssetTimeseries } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import 'moment';
import '../TimeseriesChart/index.js';
import '@cognite/griff-react';
import '../../chunks/chunk-65cf8e1d.js';
import 'numeral';
import { T as TimeseriesChartMetaPure } from '../../chunks/chunk-94869f39.js';

var TimeseriesPanelPureComponent = /** @class */ (function (_super) {
    __extends(TimeseriesPanelPureComponent, _super);
    function TimeseriesPanelPureComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TimeseriesPanelPureComponent.prototype.render = function () {
        var _a = this.props, strings = _a.strings, assetTimeseries = _a.assetTimeseries, styles = _a.styles, rest = __rest(_a, ["strings", "assetTimeseries", "styles"]);
        if (!assetTimeseries || !assetTimeseries.length) {
            return (React.createElement(NoTimeseries, { "data-test-id": "no-timeseries" }, "" + strings.noTimeseriesSign));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(TableWrapper, null,
                React.createElement(CollapseContainer, { style: styles && styles.wrapper }, assetTimeseries &&
                    assetTimeseries.map(function (ts) { return (React.createElement(PanelWrapper, { header: ts.name, key: ts.id.toString(), style: styles && styles.timeseriesContainer },
                        React.createElement(TimeseriesChartMetaPure, __assign({ key: ts.id, timeseries: ts }, rest)))); })))));
    };
    TimeseriesPanelPureComponent.defaultProps = {
        strings: {
            noTimeseriesSign: 'No timeseries linked to this asset',
        },
        theme: __assign({}, defaultTheme),
    };
    return TimeseriesPanelPureComponent;
}(React.PureComponent));
var PanelWrapper = styled(Collapse.Panel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
var TableWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  justify-content: center;\n  display: flex;\n"], ["\n  width: 100%;\n  justify-content: center;\n  display: flex;\n"])));
var CollapseContainer = styled(Collapse)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var NoTimeseries = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 16px;\n"], ["\n  padding: 16px;\n"])));
var Component = withDefaultTheme(TimeseriesPanelPureComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

// Copyright 2020 Cognite AS
var AssetTimeseriesPanel = withAssetTimeseries(Component);

export { AssetTimeseriesPanel };
